import React, { useEffect, useRef } from 'react'

import { startLivingTwin } from './livingTwin'

const REDUCED_MOTION = '(prefers-reduced-motion: reduce)'
const TWIN_OPTIONS = { maxFps: 30 } // il respiro e' lento: 30 fps bastano

// Canvas dell'animazione di login (gemello e polmoni, sullo stesso contesto
// WebGL), da mettere dentro il riquadro che ha bg.jpg come sfondo. E' solo
// decorazione: l'immagine statica resta sotto e si vede da sola se l'utente
// chiede meno animazioni, se manca WebGL o se il contesto si perde.
const LivingTwinCanvas = () => {
  const canvasRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas || window.matchMedia?.(REDUCED_MOTION)?.matches)
      return undefined
    try {
      return startLivingTwin(canvas, TWIN_OPTIONS)
    } catch {
      canvas.hidden = true
      return undefined
    }
  }, [])

  return (
    <canvas
      ref={canvasRef}
      aria-hidden="true"
      data-testid="living-twin"
      className="absolute inset-0 w-full h-full pointer-events-none"
    />
  )
}

export default LivingTwinCanvas
